import React from 'react';
import Image from 'material-ui-image'
import { __ } from '../lib/localization';

const Logo = (props) => {
    return (
        <div className={`${props.classes.logo}`}>
            <Image
                src={props.src}
                aspectRatio={props.isRectangleLogo ? (16/9) : 1}
                className={`${props.classes.logo_img}`}
                color="rgba(0,0,0,0)"
                alt={ __('leadbox_logo_tip') }
            />
        </div>
    )
}

export default Logo;
